// Estimated delivery window shown on cards and the buy box.
export function deliveryEstimate(daysFrom = 2, daysTo = 4) {
  const fmt = new Intl.DateTimeFormat("es-ES", {
    weekday: "long",
    day: "numeric",
    month: "long",
  })
  const add = (d: number) => {
    const date = new Date()
    let added = 0
    while (added < d) {
      date.setDate(date.getDate() + 1)
      const day = date.getDay()
      if (day !== 0 && day !== 6) {
        added++
      }
    }
    return date
  }
  return { from: fmt.format(add(daysFrom)), to: fmt.format(add(daysTo)) }
}
